import { render, staticRenderFns } from "./TestResultModal.vue?vue&type=template&id=323a33a6&scoped=true&"
import script from "./TestResultModal.vue?vue&type=script&lang=js&"
export * from "./TestResultModal.vue?vue&type=script&lang=js&"
import style0 from "./TestResultModal.vue?vue&type=style&index=0&id=323a33a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323a33a6",
  null
  
)

export default component.exports